import SoftReloadError from '~/common/errors/SoftReloadError.ts';
import useSoftReloadOnChunkError from '~/common/hooks/useSoftReloadOnChunkError.ts';
import { interruptWith } from '~/common/utils/error.util.tsx';

import type { PropsWithChildren } from 'react';

const DEBOUNCE_DURATION = 1000;
const RETRY_LIMIT = 5;

function ChunkErrorBoundary({ children }: PropsWithChildren) {
  const { hasRetryLimitExceeded } = useSoftReloadOnChunkError(DEBOUNCE_DURATION, RETRY_LIMIT);

  if (hasRetryLimitExceeded) {
    return interruptWith(
      new SoftReloadError(`[soft-reload] Retry limit (${RETRY_LIMIT}) exceeded. Reload skipped.`),
    );
  }

  return children;
}

export default ChunkErrorBoundary;
